import { render, staticRenderFns } from "./ImpressionTarget.vue?vue&type=template&id=5371be12&"
import script from "./ImpressionTarget.vue?vue&type=script&lang=js&"
export * from "./ImpressionTarget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports